import styled from 'styled-components';
import tw, { css } from 'twin.macro';

export const StyledPhone = styled.img`
	${tw`
  
  `}
`;
